// @flow
import React, { Component } from 'react'
import { Get } from 'api/index'
import styled from 'styled-components/macro'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { resetErrorMessage } from 'store/actions/error'

import AlertModal from 'components/modals/AlertModal'
import { t } from 'ttag'
import SearchComponent from 'components/SearchComponent'
import ResultsComponent from 'components/ResultsComponent'
import InfoModal from 'components/modals/InfoModal'
import PropTypes from 'prop-types'
import breakpoints from 'assets/stylesheet'

const FilterToggle = styled.div`
  background-color: #f5b324;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  color: white;
  height: 80px;
  width: 60px;
  position: fixed;
  z-index: 10;
  left: 0;
  top: 300px;
  cursor: pointer;
  font-size: 11px;
  line-height: 15px;
  text-align: center;
  display: ${props => (props.isSidebarVisible ? 'none' : 'block')};
  transition: box-shadow 280ms cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.5);
  }
`

const Container = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: flex-end;
  position: relative;
  z-index: 1;
  @media (max-width: ${breakpoints.bpTabletPx}) {
    overflow: hidden;
  }
`

const SearchIcon = styled.i`
  font-size: 24px;
  margin: 10px;
  cursor: pointer;
`

class Search extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isSidebarVisible: true,
      reduced: true,
      orderby: this.props.orderby,
      location: {
        hasPermission: false,
        hasResults: true,
        coords: null
      },
      currentFilters: []
    }

    this.handleSetCurrentFilters = this.handleSetCurrentFilters.bind(this)
    this.handleLocationPermissionResult = this.handleLocationPermissionResult.bind(this)
    this.toggleFilterSidebar = this.toggleFilterSidebar.bind(this)
    this.toggleSmallSidebar = this.toggleSmallSidebar.bind(this)
    this.HandleResetOrder = this.HandleResetOrder.bind(this)
  }

  async getLastUpdate() {
    const response = await Get('/api/programme/data_last_updated/')
    const data = await response
    this.setState({ lastUpdate: data.updated })
  }

  moveToTop() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search)
    const hideParam = urlParams.get('hide-sidebar')
    const programmeParam = urlParams.get('programme_id')
    this.getLastUpdate()
    if (hideParam || programmeParam) {
      this.setState({ isSidebarVisible: false })
    }
  }

  toggleFilterSidebar(collapse, button) {
    const { isSidebarVisible } = this.state
    if (collapse && button) {
      this.setState(prevState => ({
        reduced: !prevState.reduced
      }))
    } else if (!collapse && button) {
      this.setState(prevState => ({
        isSidebarVisible: !prevState.isSidebarVisible
      }))
      const crumbs = document.getElementById('crumbs')
      if (crumbs) {
        crumbs.style.left = !isSidebarVisible ? '450px' : '70px'
      }
      this.moveToTop()
    } else {
      this.setState({
        reduced: true
      })
    }
  }

  toggleSmallSidebar() {
    const { reduced } = this.state
    this.setState(prevState => ({
      reduced: !prevState.reduced
    }))
    const crumbs = document.getElementById('crumbs')
    if (crumbs) {
      crumbs.style.left = !reduced ? '450px' : '70px'
    }
    this.moveToTop()
  }

  handleLocationPermissionResult(permissionResult) {
    const { location } = this.state
    location.hasPermission = permissionResult
    this.setState({ location })
  }

  handleLocationSearchResult(hasResults) {
    const { location } = this.state
    location.hasResults = hasResults
    this.setState({ location })
  }

  handleSetCurrentFilters(currentFilters) {
    this.setState({ currentFilters })
  }

  HandleResetOrder(i) {
    this.setState({ orderby: i })
  }

  renderHeader() {
    const { searchPage } = this.props
    var text = {}
    switch (searchPage) {
      case 'projects':
        text.title = 'Search for projects and their documents'
        text.subtitle =
          'Access all the data and all the documents on thousands of projects in keep.eu. Start by telling us below which projects and/or documents you are looking for.'
        return text
      case 'programmes':
        text.title = 'Search for programmes'
        text.subtitle =
          'Access here all public information on Interreg programmes, compare their geographies and their thematic concentration. Start by filling out the filters that are important to your search, below.'
        return text
      case 'partners':
        text.title = 'What partner(s) are you looking for?'
        text.subtitle =
          "Find out where your potential partners are, their experience and what they're good at. Use the filters below. You might be surprised with your search results."
        return text
      case 'countries_and_regions':
        text.title = 'Information by countries & regions'
        text.subtitle = ''
        return text
      default:
        return null
    }
  }

  render() {
    const {
      // eslint-disable-next-line no-unused-vars
      searchPage,
      filters: { currentSearchable, selectedFilters, resultHash }
    } = this.props
    const { isSidebarVisible, location, currentFilters, orderby, reduced } = this.state
    return (
      <div className="App">
        {reduced && (
          <FilterToggle
            isSidebarVisible={isSidebarVisible}
            fullScreen={isSidebarVisible}
            onClick={this.toggleSmallSidebar}
          >
            <SearchIcon className="far fa-search" />
            <span id="mod-filters">{t`Modify search`}</span>
          </FilterToggle>
        )}
        {isSidebarVisible && (
          <div className="container-header">
            <h2>{this.renderHeader().title}</h2>
            {/*<div className="last-updated">{searchPage === 'projects' && (<>{lastUpdate && `Date of latest update: ${lastUpdate}`}</>)}</div>*/}
            <p>{this.renderHeader().subtitle}</p>
          </div>
        )}
        {
          <Container>
            {!isSidebarVisible || searchPage === 'countries_and_regions' ? (
              <>
                <SearchComponent
                  searchPage={searchPage}
                  isSidebarVisible={isSidebarVisible}
                  onToggleSideBar={this.toggleFilterSidebar}
                  onLocationPermissionResult={this.handleLocationPermissionResult}
                  setCurrentFilters={this.handleSetCurrentFilters}
                  currentFilters={currentFilters}
                  orderby={orderby}
                  resetOrder={i => this.HandleResetOrder(i)}
                  fullScreen={false}
                  reduced={reduced}
                />
                <ResultsComponent
                  currentSearchable={currentSearchable}
                  isSidebarVisible={isSidebarVisible}
                  location={location}
                  currentFilters={currentFilters}
                  selectedFilters={selectedFilters}
                  resultHash={resultHash}
                  orderby={orderby}
                  resetOrder={i => this.HandleResetOrder(i)}
                  reduced={reduced}
                />
              </>
            ) : (
              <SearchComponent
                searchPage={searchPage}
                isSidebarVisible={isSidebarVisible}
                onToggleSideBar={this.toggleFilterSidebar}
                onLocationPermissionResult={this.handleLocationPermissionResult}
                setCurrentFilters={this.handleSetCurrentFilters}
                currentFilters={currentFilters}
                orderby={'recent'}
                resetOrder={i => this.HandleResetOrder(i)}
                fullScreen={searchPage === 'countries_and_regions' ? false : true}
                reduced={reduced}
              />
            )}
          </Container>
        }
        <InfoModal />
        <AlertModal />
      </div>
    )
  }
}

Search.propTypes = {
  orderby: PropTypes.string,
  orderbyUpdate: PropTypes.func,
  resetOrder: PropTypes.bool,
  searchPage: PropTypes.string,
  filters: PropTypes.shape({
    currentSearchable: PropTypes.string,
    selectedFilters: PropTypes.object,
    resultHash: PropTypes.string,
    isPending: PropTypes.bool
  })
}

const mapStateToProps = ({ error, filters }) => ({
  error,
  filters
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      resetErrorMessage
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(Search)
